import {BatchStatementDetail} from './BatchStatementDetail';

export class BatchStatementHd  {
    overDue: string = '';
    excludeZeroTerm: boolean = false;
    emailSubject: string = '';
    emailBody: string = '';
    bccToMe: boolean = false;
    bccEmail: string = '';
    attachInvoices: boolean = false;
    detailList: BatchStatementDetail[] = [];
    invoiceDateFrom: string | null = null;
    invoiceDateTo: string | null = null;
    workWith: string = '';

    constructor(init?:Partial<BatchStatementHd>) {
        Object.assign(this, init);
    }
}
